import React from 'react';
import Header from './../inc/Header';
import Footer from './../inc/Footer';
//import Loader from './../inc/Loader';
import Menu from './../inc/Menu';
import Journals from './Journals';

import { fetchMenu } from "./../../actions/menuActionCreators";
import { fetchPage } from "./../../actions/pageActionCreators";
import { fetchOptions } from "./../../actions/optionActionCreators";
import { fetchProjects } from "./../../actions/projectActionCreators";
import { fetchPosts } from "./../../actions/postActionCreators";
import ReactFullpage from '@fullpage/react-fullpage';
import ScrollToTop from './../inc/ScrollToTop';


class Index extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			pageLoading: true
		}
	}
	componentDidMount() {
		let _this = this;
	}

	render() {
		let _this = this;
		let { menu } = this.props.menu;
	
		return (
			<main className="mole__journal">
				{/* {this.state.pageLoading &&
					<Loader />
				}  */}
				<ScrollToTop />
				<Header   {..._this.props} />
                <Journals  {..._this.props} />
				<Menu  {..._this.props} />
				<Footer  {..._this.props} />
			</main>
		);
	}
}

export default Index;


// WEBPACK FOOTER //
// ./src/components/Journal2/_index.js